import { create } from 'zustand';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

interface Toast {
  id: string;
  message: string;
  type: ToastType;
}

interface UIState {
  toasts: Toast[];
  showToast: (message: string, type?: ToastType) => void;
  dismissToast: (id: string) => void;
}

export const useUIStore = create<UIState>((set, get) => ({
  toasts: [],
  showToast: (message, type = 'info') => {
    const id = `toast-${Date.now()}-${Math.random()}`;
    set(state => ({ toasts: [...state.toasts, { id, message, type }] }));
    // Auto-dismiss après 3.5s
    setTimeout(() => get().dismissToast(id), 3500);
  },
  dismissToast: id =>
    set(state => ({ toasts: state.toasts.filter(t => t.id !== id) })),
}));
